// CANONICAL COPY (GH #7115). src/constants/frameworks/ski-0215.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

const FRAMEWORK_SKI_0215 = {
  id: 'fw-ski-0215',
  type: 'standard',
  name: 'SKI 02.15 Sikkerhedskrav',
  shortName: 'SKI 02.15',
  abbrev: 'SKI15',
  description:
    'Danish government supplier security requirements (Bilag B.3) for framework agreements 02.15 and 02.17 — 132 controls across 8 domains covering governance, personnel, asset protection, identity, vendor management, incidents, secure development and compliance.',
  color: '#c2410c',
  version: '1.0',
  jurisdiction: 'DK',
  sectionKeyDepth: 1,
  // Package tagging (SKIA-01): every mapping below carries `package` (1|2|3|null)
  // and `addOns` (string[]), sourced from Bilag B.3 "Sikkerhedspakker" (v1.0).
  // Packages are cumulative (pkg 2 includes pkg 1; pkg 3 includes pkg 1+2).
  // Add-ons are additive and independent of the baseline package. A mapping
  // with package: null is triggered exclusively by its addOns (never by any
  // baseline package tier alone) — see src/utils/skiRequirements.js.
  sections: [
    { key: '1', name: 'Governance og risikostyring' },
    { key: '2', name: 'Medarbejdersikkerhed' },
    { key: '3', name: 'Beskyttelse af aktiver' },
    { key: '4', name: 'Identitets- og adgangsstyring' },
    { key: '5', name: 'Styring af underleverandører' },
    { key: '6', name: 'Sikkerhedshændelser' },
    { key: '7', name: 'Sikkerhed i systemudvikling og -konfiguration' },
    { key: '8', name: 'Efterlevelse, opfølgning og revision' },
  ],
  mappings: [
    // ── 1. Governance og risikostyring ──────────────────────────────────────
    // 1.a Organisering af informationssikkerhed og risikostyring
    {
      externalId: 'SKI-1.a.1',
      scfId: 'SCF-GOV-002',
      section: '1',
      ref: '1.a.1',
      title: 'Udpege ansvarlig for informationssikkerhed på ledelsesniveau',
      package: 1,
      addOns: [],
      text: `Der skal være udpeget en ansvarlig for informationssikkerhed hos Leverandøren på ledelsesniveau, således at den udpegede er ansvarlig for informationssikkerheden, og at kravet opfyldes ved levering af Ydelser. Den udpegede er ansvarlig for implementering af nedenstående sikkerhedsforanstaltninger.`,
    },
    {
      externalId: 'SKI-1.a.2',
      scfId: 'SCF-RSK-001',
      section: '1',
      ref: '1.a.2',
      title: 'Gennemføre risikovurderinger mindst årligt',
      package: 1,
      addOns: [],
      text: `Leverandøren skal gennemføre risikovurderinger for de forretningsmiljøer, processer, forretningsapplikationer, computersystemer, tekniske platforme og netværk, der anvendes til levering af Ydelser til Kunden mindst en gang om året og ved større ændringer i interne eller eksterne forhold.`,
    },
    {
      externalId: 'SKI-1.a.3',
      scfId: 'SCF-RSK-001',
      section: '1',
      ref: '1.a.3',
      title: 'Anvende dokumenteret og konsistent risikovurderingsmetode',
      package: 2,
      addOns: [],
      text: `Til udarbejdelse af ovenstående risikovurderinger skal der anvendes en risikovurderingsmetode, som bruges konsistent hos Leverandøren, er dokumenteret og regelmæssigt opdateret.`,
    },
    {
      externalId: 'SKI-1.a.4',
      scfId: 'SCF-RSK-001',
      section: '1',
      ref: '1.a.4',
      title: 'Risikovurdering skal afdække CIA-trusler, sårbar­heder og konsekvenser',
      package: 3,
      addOns: [],
      text: `Risikovurderinger i henhold til krav-id 1.a.2 skal identificere risici ved at vurdere følgende forhold, i det omfang de måtte være relevante for levering af en eller flere Ydelser:

- den potentielle konsekvens for både Leverandøren og Kunden ved en hændelse det i tekniske miljø, forretningsprocesser, information og systemer
- forsætlige og utilsigtede trusler mod fortroligheden, integriteten og tilgængeligheden af de tjenester, som Leverandøren leverer til Kunden
- trusler fra internt personale og eksterne parter
- menneskeskabte hændelser, naturkatastrofer eller pandemier
- sårbarheder som følge af kontrolsvagheder
- sårbarheder i det tekniske miljø, der øger sandsynligheden for, at der opstår en alvorlig informationssikkerhedshændelse`,
    },
    {
      externalId: 'SKI-1.a.5',
      scfId: 'SCF-RSK-001',
      section: '1',
      ref: '1.a.5',
      title: 'Risikovurdering afspejler compliance, SLA og trussels­rapporter',
      package: 3,
      addOns: [],
      text: `Ved udarbejdelse af risikovurderingen skal Leverandøren sørge for at denne i det store hele afspejler:

- compliance krav (f.eks GDPR)
- eventuelle Service Level Agreements med Kunden
- resultat af tidligere risikovurderinger
- karakteristika ved driftsmiljøet, der vurderes
- de fysiske placeringer, der er knyttet til risikovurderingen
- tidligere oplevede hændelser
- relevante revisions- og revisionsrapporter fra interne/eksterne revisorer og tilsynsmyndigheder
- trusselsrapporter fra relevante interne og pålidelige eksterne kilder,

Kunden skal informeres om identificerede risici og handlinger til mitigering heraf.`,
    },
    {
      externalId: 'SKI-1.a.6',
      scfId: 'SCF-MSS-005',
      section: '1',
      ref: '1.a.6',
      title: 'Regelmæssig monitering og rapportering af kontroleffektivitet til ledelse og kunde',
      package: 3,
      addOns: [],
      text: `Leverandøren skal regelmæssigt monitorere og følge op på effektiviteten af de implementerede sikkerhedsforanstaltninger ved at:

- have politikker og procedurer, der beskriver, hvordan opfølgningen foregår, herunder hvilke metoder, der anvendes til at vurdere effektiviteten af sikkerhedsforanstaltningerne
- gennemføre vurdering af effektiviteten af de implementerede sikkerhedsforanstaltninger
- Leverandørens ledelse informeres om status på og effektiviteten af sikkerhedsforanstaltningerne
- identificere og implementere sikkerhedsforanstaltningerne, så risici kontinuerligt minimeres

Kunden skal informeres om effektiviteten af sikringsforanstaltningerne og eventuelle yderligere tiltag til mitigering af risici i det omfang det er relevant for leveringen af Ydelser.`,
    },

    // 1.b Politik for informationssikkerhed
    {
      externalId: 'SKI-1.b.1',
      scfId: 'SCF-GOV-001',
      section: '1',
      ref: '1.b.1',
      title: 'Dokumenteret og ledelsesgodkendt informationssikkerhedspolitik',
      package: 1,
      addOns: [],
      text: `Der skal være en dokumenteret og ledelsesgodkendt informationssikkerhedspolitik, der specificerer principperne for informationssikkerhed og beskriver organisationens tilgang til styring af informationssikkerhed og gælder på tværs af organisationen således, at kravene opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-1.b.2',
      scfId: 'SCF-GOV-001',
      section: '1',
      ref: '1.b.2',
      title: 'Politik kræver klassifikation og CIA-beskyttelse af information',
      package: 1,
      addOns: [],
      text: `Informationssikkerhedspolitikken skal gælde for organisationen og stille krav om, at informationer er:

- klassificerede på en måde, der angiver dens kritikalitet og følsomhed
- beskyttet med hensyn til fortrolighed, integritet og tilgængelighed

således, at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-1.b.3',
      scfId: 'SCF-GOV-001',
      section: '1',
      ref: '1.b.3',
      title: 'Politik tager højde for juridiske, kontraktlige og trusselsmæssige krav',
      package: 2,
      addOns: [],
      text: `Informationssikkerhedspolitikken skal tage højde for relevante krav, der stammer fra:

- forretnings- og it-strategi
- juridiske, lovgivningsmæssige og kontraktmæssige krav
- det nuværende og forventede trusselsbillede

således, at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-1.b.4',
      scfId: 'SCF-GOV-001',
      section: '1',
      ref: '1.b.4',
      title: 'Understøttende procedurer og retningslinjer udstedes under politikken',
      package: 2,
      addOns: [],
      text: `Informationssikkerhedspolitikken skal stille krav til, at der er udarbejdet procedurer, processer og retningslinjer, som understøtter den overordnede informationssikkerhedspolitik, således at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-1.b.5',
      scfId: 'SCF-PPL-003',
      section: '1',
      ref: '1.b.5',
      title: 'Medarbejdere gøres opmærksomme på IS og forventet sikkerhedsadfærd',
      package: 2,
      addOns: [],
      text: `Informationssikkerhedspolitikken, jf. ovenfor, skal stille krav til, at Leverandørens medarbejdere gøres opmærksom på informationssikkerhed og deres forventede sikkerhedsadfærd`,
    },
    {
      externalId: 'SKI-1.b.6',
      scfId: 'SCF-GOV-001',
      section: '1',
      ref: '1.b.6',
      title: 'Informationssikkerhedspolitik kommunikeret til alle medarbejdere',
      package: 2,
      addOns: [],
      text: `Informationssikkerhedspolitikken, jf. ovenfor, skal være kommunikeret til alle medarbejdere.`,
    },
    {
      externalId: 'SKI-1.b.7',
      scfId: 'SCF-MSS-005',
      section: '1',
      ref: '1.b.7',
      title: 'Metode til regelmæssig verificering af politikoverholdelse',
      package: 2,
      addOns: [],
      text: `Der skal være en metode til regelmæssigt at vurdere, at informationssikkerhedspolitikken og understøttende politikker (f.eks. i form af sikkerhedsgennemgange) overholdes.`,
    },
    {
      externalId: 'SKI-1.b.8',
      scfId: 'SCF-GOV-001',
      section: '1',
      ref: '1.b.8',
      title: 'Politik gennemgås regelmæssigt efter dokumenteret reviewproces',
      package: 2,
      addOns: [],
      text: `Informationssikkerhedspolitikken, jf. ovenfor, skal gennemgås regelmæssigt i henhold til en defineret og dokumenteret reviewproces.`,
    },
    {
      externalId: 'SKI-1.b.9',
      scfId: 'SCF-GOV-001',
      section: '1',
      ref: '1.b.9',
      title: 'Politik tilpasses rettidigt ændrede omstændigheder',
      package: 3,
      addOns: [],
      text: `Informationssikkerhedspolitikken, jf. ovenfor, skal rettidigt tilpasses ændrede omstændigheder, (f.eks. nye trusler, nye eller forbedrede kontrolteknikker, ændret forretningsstrategi, organisatoriske ændringer, opdateringer af kontraktmæssige, retlige og reguleringsmæssige krav eller ændringer af den tekniske infrastruktur).`,
    },
    {
      externalId: 'SKI-1.b.10',
      scfId: 'SCF-PPL-008',
      section: '1',
      ref: '1.b.10',
      title: 'Kommunikationskanaler til indberetning af politikbrud',
      package: 3,
      addOns: [],
      text: `Der skal være etableret kommunikationskanaler, hvor brud på informationssikkerhedspolitikken, jf. ovenfor, kan indberettes.`,
    },
    {
      externalId: 'SKI-1.b.11',
      scfId: 'SCF-GOV-001',
      section: '1',
      ref: '1.b.11',
      title: 'Processer til håndtering af afvigelser og undtagelser fra politikken',
      package: 3,
      addOns: [],
      text: `Der skal være etableret processer til håndtering af afvigelser og undtagelser fra informationssikkerhedspolitikken, jf. ovenfor.`,
    },
    {
      externalId: 'SKI-1.b.12',
      scfId: 'SCF-PPL-008',
      section: '1',
      ref: '1.b.12',
      title: 'Medarbejdere pålægges at indberette politikbrud og IS-svagheder',
      package: 3,
      addOns: [],
      text: `Informationssikkerhedspolitikken skal stille krav til, at medarbejdere og samarbejdspartnere indberetter brud på informationssikkerhedspolitikken, jf. ovenfor, og mistanke om informationssikkerhedssvagheder, herunder brud på og mistanke om informationssikkerhedssvagheder.`,
    },

    // 1.c Disciplinære foranstaltninger
    {
      externalId: 'SKI-1.c.1',
      scfId: 'SCF-PPL-004',
      section: '1',
      ref: '1.c.1',
      title: 'Disciplinærproces ved overtrædelse af informationssikkerhedspolitik',
      package: 2,
      addOns: [],
      text: `En proces for at træffe disciplinære foranstaltninger, hvis informationssikkerhedspolitikken, jf. ovenfor, eller understøttende politikker (herunder politikker for acceptabel brug) ikke følges, skal være beskrevet og kommunikeret til alle medarbejdere, således, at kravet opfyldes ved levering af Ydelser.`,
    },

    // ── 2. Medarbejdersikkerhed ─────────────────────────────────────────────
    // 2.a Baggrundsverifikation
    {
      externalId: 'SKI-2.a.1',
      scfId: 'SCF-PPL-001',
      section: '2',
      ref: '2.a.1',
      title: 'Screening af medarbejdere ved ansættelse eller inden kontraktstart',
      package: 1,
      addOns: [],
      text: `Medarbejdere, der medvirker til levering af Ydelser, skal være screenet enten ved ansættelse eller inden arbejdet på Leveringskontrakten påbegyndes (f.eks. ved at indhente referencer, kontrollere karrierehistorik/kvalifikationer, straffeattest og bekræfte identitet).`,
    },
    {
      externalId: 'SKI-2.a.2',
      scfId: 'SCF-PPL-001',
      section: '2',
      ref: '2.a.2',
      title: 'Screeningskrav indgår i aftaler med rekrutteringsbureauer og tredjeparter',
      package: 1,
      addOns: [],
      text: `Hvis enkeltpersoner (medarbejdere og underleverandører, herunder disses medarbejdere) ansættes i relation til Leveringskontraktens opfyldelse, gennem tredjeparter (f.eks. rekrutteringsbureauer), skal screeningskrav medtages i de kontraktlige aftaler med tredjeparten.`,
    },
    {
      externalId: 'SKI-2.a.3',
      scfId: 'SCF-PPL-001',
      section: '2',
      ref: '2.a.3',
      title: 'Skærpet adgangsbegrænsning ved ufuldstændig screening',
      package: 2,
      addOns: [],
      text: `Screeningsprocessen skal indeholde skærpede krav til adgangsbegrænsninger, hvis screeningen ikke kan afsluttes før arbejdet med Leveringskontrakten påbegyndes.`,
    },
    {
      externalId: 'SKI-2.a.4',
      scfId: 'SCF-PPL-001',
      section: '2',
      ref: '2.a.4',
      title: 'National sikkerhedsgodkendelse for roller med adgang til kritisk infrastruktur',
      package: 3,
      addOns: [],
      text: `Screeningsprocessen i henhold til krav-id 2.a.1 skal understøttes af:

- en defineret tilgang, herunder kriterier for gennemførelse af screening og enkeltpersoners roller og ansvar (f.eks. hvem der udfører screeningen)
- mere detaljeret screening, når rollen indebærer adgang til kritiske eller følsomme oplysninger eller systemer
- eksterne agenturer, hvor en rolle kræver nationale sikkerhedsgodkendelser eller kontrol af strafferegistre.`,
    },

    // 2.b Fortrolighedsaftaler
    {
      externalId: 'SKI-2.b.1',
      scfId: 'SCF-PPL-002',
      section: '2',
      ref: '2.b.1',
      title: 'Medarbejdere accepterer ansættelses- og kontraktvilkår skriftligt',
      package: 1,
      addOns: [],
      text: `Medarbejdere, der medvirker til levering af Ydelser, skal acceptere de nedenfor nævnte ansættelses- og/eller kontraktvilkår Skriftligt.`,
    },
    {
      externalId: 'SKI-2.b.2',
      scfId: 'SCF-PPL-002',
      section: '2',
      ref: '2.b.2',
      title: 'IS-ansvar specificeret i ansættelses- og kontraktvilkår',
      package: 1,
      addOns: [],
      text: `Medarbejdernes ansvar for informationssikkerhed specificeres i ansættelses - og/eller kontraktvilkår (f.eks. i medarbejderhåndbog eller adfærdskodeks), således at kravet overholdes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-2.b.3',
      scfId: 'SCF-PPL-002',
      section: '2',
      ref: '2.b.3',
      title: 'Vilkår kræver politikoverholdelse, NDA og konsekvensoplysning',
      package: 1,
      addOns: [],
      text: `Ansættelses- og/eller kontraktvilkårene, jf. ovenfor, skal:

- kræve, at medarbejderne overholder leverandørens informationssikkerhedspolitik, understøttende politikker (f.eks. politikker for acceptabel brug) og procedurer/retningslinjer
- indeholde en fortrolighedsklausul (eller separat fortrolighedsaftale)
- uddybe konsekvensen af manglende overholdelse af informationssikkerhedspolitikken og understøttende politikker.`,
    },
    {
      externalId: 'SKI-2.b.4',
      scfId: 'SCF-PPL-002',
      section: '2',
      ref: '2.b.4',
      title: 'IS-ansvar strækker sig ud over normal arbejdstid og fortsætter efter ophør',
      package: 1,
      addOns: [],
      text: `Medarbejdere skal i ansættelses- og/eller kontraktvilkår oplyses om, at informationssikkerhedsansvaret, jf. informationssikkerhedspolitikken ovenfor, strækker sig udover normal arbejdstid og lokaler, samt hvilke dele, der fortsætter efter ansættelsesforholdets og/eller kontraktens ophør.`,
    },
    {
      externalId: 'SKI-2.b.5',
      scfId: 'SCF-PPL-002',
      section: '2',
      ref: '2.b.5',
      title: 'Konsekvenser af manglende politikoverholdelse kommunikeret i vilkår',
      package: 2,
      addOns: [],
      text: `Medarbejdere i ansættelses- og/eller kontraktvilkår skal oplyses om konsekvensen af manglende overholdelse af informationssikkerhedspolitikken og understøttende politikker.`,
    },
    {
      externalId: 'SKI-2.b.6',
      scfId: 'SCF-PPL-006',
      section: '2',
      ref: '2.b.6',
      title: 'Fortrolighedsaftale (NDA) indgås med alle medvirkende medarbejdere',
      package: 2,
      addOns: [],
      text: `Der skal indgås fortrolighedsaftale med alle medarbejdere, der medvirker til levering af Ydelser. Fortrolighedsaftalen skal specificeres:

- typer oplysninger, der skal beskyttes
- betingelser for, hvornår og hvordan oplysninger må bruges
- underskrivernes ansvar for at undgå uautoriseret videregivelse af oplysninger.`,
    },
    {
      externalId: 'SKI-2.b.7',
      scfId: 'SCF-PPL-006',
      section: '2',
      ref: '2.b.7',
      title: 'NDA inkluderer processer for indberetning, håndtering, ophør og destruktion',
      package: 3,
      addOns: [],
      text: `En fortrolighedsaftale i forhold til krav-id 2.b.6 skal omfatte processer for:

- indberetning af uautoriseret videregivelse af oplysninger
- håndtering af manglende overholdelse af aftalen
- opsigelse af aftalen
- returnering eller destruktion af oplysninger efter aftalens ophør.`,
    },

    // 2.c Politik for acceptabel brug
    {
      externalId: 'SKI-2.c.1',
      scfId: 'SCF-AST-002',
      section: '2',
      ref: '2.c.1',
      title: 'Dokumenteret og kommunikeret politik for acceptabel brug af udstyr og data',
      package: 1,
      addOns: [],
      text: `Der skal være en dokumenteret politik for acceptabel brug af udstyr og data, herunder en dokumenteret politik for acceptabel brug af udstyr og data der indgår ved levering af Ydelser, der:

- er let tilgængelig og kommunikeret til alle medarbejdere med adgang til Leverandørens netværk og systemer
- angiver de overvågningsaktiviteter, der udføres, (f.eks. vedrørende medarbejdernes netværksbrug, system- eller dokumentadgang mv.)`,
    },
    {
      externalId: 'SKI-2.c.2',
      scfId: 'SCF-AST-002',
      section: '2',
      ref: '2.c.2',
      title: 'AUP understøttet af retningslinjer om brug af informationer og aktiver',
      package: 2,
      addOns: [],
      text: `Leverandørens politik for acceptabel brug af udstyr og data, skal være understøttet af retningslinjer, der giver medarbejderne yderligere oplysninger om, hvordan de må bruge informationer, systemer, og aktiver, herunder kundedata.`,
    },
    {
      externalId: 'SKI-2.c.3',
      scfId: 'SCF-AST-002',
      section: '2',
      ref: '2.c.3',
      title: 'AUP specificerer ejerskab, tilladt/forbudt brug og forventet adfærd',
      package: 2,
      addOns: [],
      text: `Retningslinjerne for acceptabel brug af udstyr og data (AUP) skal angive:

- ejerskab til og formål med de informationer og systemer, der anvendes af medarbejderne
- tilladt og forbudt brug af informationer, systemer og aktiver
- forventet sikkerhedsadfærd hos medarbejderne, herunder brug af stærke adgangskoder, kryptering, screensaver mv.
- uacceptabel adfærd`,
    },

    // 2.d Awareness og træning
    {
      externalId: 'SKI-2.d.1',
      scfId: 'SCF-PPL-003',
      section: '2',
      ref: '2.d.1',
      title: 'Introduktionsuddannelse i IS til alle medvirkende medarbejdere',
      package: 1,
      addOns: [],
      text: `Der skal gives introduktionstræning i informationssikkerhed til alle medarbejdere, som oplyser dem om deres ansvar for informationssikkerhed, og som gør dem i stand til at udvise den forventede sikkerhedsadfærd således, at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-2.d.2',
      scfId: 'SCF-PPL-003',
      section: '2',
      ref: '2.d.2',
      title: 'Regelmæssig obligatorisk awarenesstræning tilpasset roller',
      package: 1,
      addOns: [],
      text: `Leverandøren skal med passende mellemrum sørge for obligatorisk awarenesstræning til alle medarbejdere for at fremme og integrere forventet sikkerhedsadfærd, således kravet opfyldes ved levering af Ydelser.

Træningen skal tilpasses målgruppernes roller og ansvarsområder.`,
    },
    {
      externalId: 'SKI-2.d.3',
      scfId: 'SCF-PPL-003',
      section: '2',
      ref: '2.d.3',
      title: 'Træning dækker trusselsbillede, politikker og beskyttelsesformål',
      package: 1,
      addOns: [],
      text: `Medarbejderne skal i forbindelse med ovenstående introduktions- og awarenesstræning gøres opmærksomme på:

- at informationssikkerhed er nødvendig for at beskytte oplysninger og systemer
- de almindelige typer trusselshændelser, som Leverandøren står over for
- vigtigheden af at overholde informationssikkerhedspolitikker og anvende tilknyttede standarder/procedurer`,
    },
    {
      externalId: 'SKI-2.d.4',
      scfId: 'SCF-PPL-003',
      section: '2',
      ref: '2.d.4',
      title: 'Træning dækker phishing, social manipulation og fysiske trusler',
      package: 2,
      addOns: [],
      text: `Awareness-træningen i henhold til krav-id 2.d.2 skal indeholde oplysninger om trusler i forbindelse med:

- personer, (f.eks. phishing-angreb, social manipulation eller utilsigtet informationslækage)
- fysisk placering, tab eller tyveri af mobile enheder, flytbare medier mv.`,
    },
    {
      externalId: 'SKI-2.d.5',
      scfId: 'SCF-PPL-003',
      section: '2',
      ref: '2.d.5',
      title: 'Træning fremmer sikkerhedsadfærd inkl. deepfakes, clear desk og skærmlås',
      package: 2,
      addOns: [],
      text: `Den forventede sikkerhedsadfærd, jf. 2.d.1, skal fremmes ved at:

- definere forventet sikkerhedsrelateret adfærd
- forklare betydningen af informationssikkerhed (dvs. beskyttelse af oplysningernes fortrolighed, integritet og tilgængelighed)
- eksemplificere nye og kommende trusler, som f.eks. deepfakes, digitale dobbeltgængere mv.
- forklare vigtigheden af overholdelse af politikker for f.eks. clear desk og låsning af skærm,`,
    },
    {
      externalId: 'SKI-2.d.6',
      scfId: 'SCF-PPL-003',
      section: '2',
      ref: '2.d.6',
      title: 'Træning dækker dokumenthåndtering, fysisk adgangskontrol og off-site sikkerhed',
      package: 2,
      addOns: [],
      text: `Medarbejdere skal undervises i forbindelse med ovenstående introduktions- og awarenesstræning :

- processer for f.eks. dokumenthåndtering og sikker bortskaffelse
- handlinger og adfærd til at håndtere kendte trusler (f.eks. social engineering)
- metoder til begrænsning af fysisk adgang til Leverandørens faciliteter (f.eks. kontrol af identiteten af fremmede eller personer uden for organisationen, som har anmodet om fysisk adgang, og krav om, at de følger dokumenterede adgangsstyringsprocedurer)
- sikkerhedsordninger, ved håndtering af oplysninger, der ligger uden for organisationens kontrol (f.eks. ved hjemmearbejde eller rejser og ved brug af telefon- og talemeddelelsestjenester),`,
    },
    {
      externalId: 'SKI-2.d.7',
      scfId: 'SCF-PPL-003',
      section: '2',
      ref: '2.d.7',
      title: 'Træning integrerer IS i daglige aktiviteter: passwords, MFA, opdateringer',
      package: 2,
      addOns: [],
      text: `Medarbejdere skal i forbindelse med nedenstående træning skal undervises i at inkorporere informationssikkerhed i regelmæssige daglige aktiviteter f.eks. brug af sikre passwords, to-faktor godkendelse og sikkerhedsopdateringer af mobile enheder)`,
    },
    {
      externalId: 'SKI-2.d.8',
      scfId: 'SCF-PPL-003',
      section: '2',
      ref: '2.d.8',
      title: 'Træning dækker sikker brug af kommunikation, VPN og hjemmenetværk',
      package: 3,
      addOns: [],
      text: `Medarbejdere skal i forbindelse med nedenstående træning gives uddannelse/træning i sikker brug af:

- talekommunikationstjenester og konferenceudstyr, herunder telekonference- og videokonferencefaciliteter
- adgangskontrolmekanismer (f.eks. adgangskoder, tokens mv.)
- hjemmenetværk, hvis arbejde hjemmefra tillades
- netværksforbindelse (f.eks. kryptering af trådløse netværk og brug af et virtuelt privat netværk (VPN), når der oprettes forbindelse til Leverandørens (eller Kundens) netværk)
- elektroniske kommunikationsteknologier, herunder e-mailsystemer og samarbejdsplatforme,`,
    },
    {
      externalId: 'SKI-2.d.9',
      scfId: 'SCF-PPL-003',
      section: '2',
      ref: '2.d.9',
      title: 'Træning dækker ansvar for fortrolighed og ikke-videregivelse',
      package: 3,
      addOns: [],
      text: `Medarbejdere skal i forbindelse med nedenstående træning undervises i deres ansvar for informationer og i ikke at videregive fortrolige eller følsomme oplysninger til uautoriserede personer.`,
    },

    // 2.e Medarbejdersikkerhed efter ansættelsesophør
    {
      externalId: 'SKI-2.e.1',
      scfId: 'SCF-PPL-005',
      section: '2',
      ref: '2.e.1',
      title: 'IS-ansvar kommunikeres ved opsigelse eller ændring af ansættelsesforhold',
      package: 1,
      addOns: [],
      text: `Ved opsigelse eller ændring af ansættelses- og/eller kontraktforholdet skal Leverandørens medarbejdere, der medvirker eller har medvirket til levering af Ydelser, gøres opmærksomme på deres ansvar for informationssikkerhed, jf. ovenfor, der er specificeret i ansættelses- og/eller kontraktvilkårene, og som forbliver gyldigt, efter at ansættelsen og/eller kontrakten er ophørt eller ændret.`,
    },
    {
      externalId: 'SKI-2.e.2',
      scfId: 'SCF-AST-003',
      section: '2',
      ref: '2.e.2',
      title: 'Tilbagelevering af udstyr, software, tokens og data ved fratrædelse',
      package: 1,
      addOns: [],
      text: `Ved ansættelses- og/eller kontraktforholdets ophør skal medarbejdere, der medvirker eller har medvirket til levering af Ydelser, være forpligtet til at tilbagelevere aktiver, der ikke tilhører medarbejderen, herunder:

- udstyr (f.eks. bærbare computere, tablets, smartphones, flytbare medier mv)
- software (herunder medier, dokumentation og licensoplysninger)
- udstyr til autentifikation (f.eks. fysiske tokens, chipkort, adgangskort mv.)
- data og informationer`,
    },
    {
      externalId: 'SKI-2.e.3',
      scfId: 'SCF-PPL-005',
      section: '2',
      ref: '2.e.3',
      title: 'Skriftlig bekræftelse på returnering af alle kopier af kundedata ved fratrædelse',
      package: 2,
      addOns: [],
      text: `Ved ansættelses- og/eller kontraktforholdets ophør eller ændring skal medarbejdere, der medvirker eller har medvirket til levering af Ydelser, være forpligtet til at bekræfte (Skriftligt), at de har returneret alle kopier af data, der ejes af Kunden, herunder oplysninger, der er lagret på medarbejderejede enheder`,
    },
    {
      externalId: 'SKI-2.e.4',
      scfId: 'SCF-DAT-005',
      section: '2',
      ref: '2.e.4',
      title: 'Kopiering af kritiske/følsomme oplysninger begrænses i opsigelsesperioden',
      package: 3,
      addOns: [],
      text: `Ved ansættelses- og/eller kontraktforholdets ophør skal medarbejderes, der medvirker eller har medvirket til levering af Ydelser, kopiering af kritiske eller følsomme oplysninger i deres opsigelsesperiode begrænses mest muligt.`,
    },

    // ── 3. Beskyttelse af aktiver ───────────────────────────────────────────
    // 3.a Slutbrugerudstyr
    {
      externalId: 'SKI-3.a.1',
      scfId: 'SCF-AST-001',
      section: '3',
      ref: '3.a.1',
      title: 'Identificere og vedligeholde fortegnelse over slutbrugerudstyr med aktivejer',
      package: null,
      addOns: ['mobile'],
      text: `Leverandøren skal identificere og vedligeholde en fortegnelse over de aktiver (slutbrugerudstyr), der anvendes til levering af Ydelser. Leverandøren skal udpege en aktivejer, for det pågældende aktivs livscyklus.`,
    },
    {
      externalId: 'SKI-3.a.2',
      scfId: 'SCF-OPS-005',
      section: '3',
      ref: '3.a.2',
      title: 'Dokumenterede standarder for hardning og sikring af slutbrugerudstyr',
      package: null,
      addOns: ['mobile'],
      text: `For slutbrugerudstyr, der anvendes til levering af Ydelser, skal der være dokumenterede standarder/procedurer for sikring af enhederne, som omfatter:

- anvendelse af standardkonfigurationer
- hardning af enheden
- installation af sikkerhedssoftware
- beskyttelse mod netværk, der ikke er tillid til,

så der opnås et beskyttelsesniveau, der er tilstrækkeligt for anvendelsen af enheden.`,
    },
    {
      externalId: 'SKI-3.a.3',
      scfId: 'SCF-OPS-005',
      section: '3',
      ref: '3.a.3',
      title:
        'Tekniske standardkonfigurationer: godkendt OS, adgangskontrol, ingen uautoriseret fjernstyring',
      package: null,
      addOns: ['mobile'],
      text: `Slutbrugerudstyret, der anvendes til levering af Ydelser, skal være forsynet med tekniske standardkonfigurationer, der omfatter:

- et standardoperativsystem, pålidelige og godkendte programmer, kommunikationssoftware og sikkerhedssoftware
- implementering af adgangskontrolmekanismer for at begrænse adgangen til et begrænset antal brugere og administratorer til enheden
- at forhindre adgang til enheden ved hjælp af uautoriseret fjernbetjeningssoftware`,
    },
    {
      externalId: 'SKI-3.a.4',
      scfId: 'SCF-OPS-004',
      section: '3',
      ref: '3.a.4',
      title: 'Automatisk installation af OS-opdateringer og sikkerhedsrettelser',
      package: null,
      addOns: ['mobile'],
      text: `Slutbrugerudstyret, der anvendes til levering af Ydelser, skal konfigureres til at installere nye versioner af operativsystemet og implementere sikkerhedsopdateringer så hurtigt som muligt`,
    },
    {
      externalId: 'SKI-3.a.5',
      scfId: 'SCF-OPS-003',
      section: '3',
      ref: '3.a.5',
      title: 'Opdateret malwarebeskyttelse og filbaseret kryptering på slutbrugerudstyr',
      package: null,
      addOns: ['mobile'],
      text: `Standardkonfigurationer, jf. krav 3.a.3, på slutbrugerudstyret skal omfatte:

- opdateret software til beskyttelse mod malware (herunder programkode og signaturfiler)
- filbaseret krypteringssoftware til beskyttelse af individuelle filer og mapper`,
    },
    {
      externalId: 'SKI-3.a.6',
      scfId: 'SCF-OPS-005',
      section: '3',
      ref: '3.a.6',
      title: 'Konfigurationer etableret via images, holdt ajour og overvåget regelmæssigt',
      package: null,
      addOns: ['mobile'],
      text: `Standardkonfigurationer, jf. krav 3.a.3, skal være:

- etableret ved hjælp af standardiserede, foruddefinerede images
- holdt ajour med de seneste programrettelser og ændringer i konfiguration
- overvåget med systemadministrationsværktøjer (f.eks. fjernsupport og backupsoftware)
- gennemgået regelmæssigt for at kontrollere, at konfigurationsindstillingerne fortsat er passende (f.eks. når nye trusler eller sårbarheder skal håndteres, eller når nye software- eller hardwareversioner introduceres),`,
    },
    {
      externalId: 'SKI-3.a.7',
      scfId: 'SCF-IAM-003',
      section: '3',
      ref: '3.a.7',
      title:
        'Adgangskontrol på enhed: omdøbte adminkonti, min. 12 tegn adgangskoder, timeout, ingen klartekst',
      package: null,
      addOns: ['mobile'],
      text: `Standardkonfigurationer, jf. krav 3.a.3, skal forhindre uautoriseret adgang ved at:

- omdøbe administratorkonti, minimere af antallet af konti med adgangsrettigheder på administratorniveau og ændre standardadgangskoder til administration af enheden
- bruge godkendte adgangskontrolmekanismer (f.eks. adgangskoder på minimum 6 karakterer/biometri på telefoner, minimum 12 karakterer på tablets og pc'ere mv.) til at begrænse adgangen til enheden til autoriserede brugere og administratorer
- adgangskoder ikke gemmes i klar tekst
- aktivere timeoutfaciliteter, så brugerne efter en forudbestemt periode med inaktivitet skal logge på igen, for fortsat brug,`,
    },
    {
      externalId: 'SKI-3.a.8',
      scfId: 'SCF-OPS-005',
      section: '3',
      ref: '3.a.8',
      title:
        'Firmwarekonfiguration: BIOS/UEFI-begrænsninger, boot-restriktioner, minimering af tjenester',
      package: null,
      addOns: ['mobile'],
      text: `Standardfirmwarekonfigurationer skal omfatte:

- anvendelse af forud konfigurerede firmwaregrænsefladeindstillinger (f.eks. BIOS eller UEFI) for at begrænse funktionalitet (f.eks. for at deaktivere opstartsmenuen eller USB/DVD-opstartsindstillinger)
- begrænsning af adgangen til firmwaregrænsefladeindstillinger til autoriserede administratorer (f.eks. ved hjælp af adgangskodebeskyttelse)
- begrænsning eller deaktivering af unødvendige tjenester, protokoller, systemværktøjer eller kommandoprocesser,

således, at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-3.a.9',
      scfId: 'SCF-OPS-001',
      section: '3',
      ref: '3.a.9',
      title: 'Netværksbeskyttelse på slutbrugerudstyr: firewall, Always On VPN, HIDS, hændelseslog',
      package: null,
      addOns: ['mobile'],
      text: `Slutbrugerudstyr, der kan oprette forbindelse til netværk, der ikke er tillid til (herunder internettet), skal beskyttes af:

- installation og vedligeholdelse af firewalls eller tilsvarende for at begrænse indgående og udgående netværkstrafik
- aktivering af sikkerhedsrelateret hændelseslog (f.eks. log af hændelser, der er knyttet til bestemte forretningsprogrammer eller mapper, der indeholder følsomme oplysninger)
- anvendelse af Always On VPN
- implementering af HIDS-software (Host-based Intrusion Detection System),

således, at kravet opfyldes ved levering af Ydelser`,
    },
    {
      externalId: 'SKI-3.a.10',
      scfId: 'SCF-DAT-005',
      section: '3',
      ref: '3.a.10',
      title: 'Fuld diskkryptering og DLP-foranstaltninger der forhindrer datalækage',
      package: null,
      addOns: ['mobile'],
      text: `Der skal være implementeret foranstaltninger, der forhindrer data lækage. Dette indebærer f.eks.:

- fuld diskkryptering af enheden
- brugen af/forbindelsen til flytbare medier overvåges og registreres
- kopiering af følsomme filer begrænses til kun godkendte flytbare medier,

således, at kravet opfyldes ved levering af Ydelser`,
    },

    // 3.b Bærbare medier
    {
      externalId: 'SKI-3.b.1',
      scfId: 'SCF-PHY-010',
      section: '3',
      ref: '3.b.1',
      title: 'Dokumenterede procedurer for brug af bærbare medier inkl. fortrolighedsbeskyttelse',
      package: 1,
      addOns: [],
      text: `Der skal være dokumenterede procedurer for brug af bærbare medier, som omfatter:

- hvornår det er tilladt at benytte bærbare medier
- hvordan information på bærbare medier skal beskyttes i henhold til fortrolighed
- fastlagte begrænsninger i brug af bærbare medier,

således, at kravet opfyldes ved levering af Ydelser`,
    },
    {
      externalId: 'SKI-3.b.2',
      scfId: 'SCF-PHY-010',
      section: '3',
      ref: '3.b.2',
      title: 'Brugere informeres om tilladte medier, aktiviteter og sikker destruktion',
      package: 1,
      addOns: [],
      text: `Brugerne af bærbare medier skal oplyses om:

- hvilke medier, der er tilladt til lagring eller overførsel af forskellige typer af information
- hvilke aktiviteter, der er tilladt at benytte de bærbare medier til
- hvordan de destruerer filer på en sikker måde,

således, at kravet opfyldes ved levering af Ydelser`,
    },
    {
      externalId: 'SKI-3.b.3',
      scfId: 'SCF-PHY-010',
      section: '3',
      ref: '3.b.3',
      title: 'Forbud mod deling af bærbare medier eller adgangskoder til uautoriserede',
      package: 1,
      addOns: [],
      text: `Brugere af bærbare medier må ikke dele enheden eller videregive adgangskode til mediet til uautoriserede personer

således, at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-3.b.4',
      scfId: 'SCF-PHY-010',
      section: '3',
      ref: '3.b.4',
      title: 'Bærbare medier beskyttes med logning og adgangskontrol/kryptering',
      package: 2,
      addOns: [],
      text: `Bærbare medier skal beskyttes ved:

- en proces for registrering og logning af brug af mediet
- adgangskontrolmekanismer og/eller krypteringsteknikker,

således, at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-3.b.5',
      scfId: 'SCF-PHY-010',
      section: '3',
      ref: '3.b.5',
      title: 'Bærbare medier opbevares sikkert, gennemgås og returneres ved ophør',
      package: 2,
      addOns: [],
      text: `Bærbare medier, der anvendes til levering af Ydelser, skal:

- opbevares sikkert når de ikke er i brug
- gennemgås regelmæssigt for indhold for identifikation af filer, der skal slettes
- returneres til medarbejderens organisation, når det ikke længere skal anvendes,`,
    },
    {
      externalId: 'SKI-3.b.6',
      scfId: 'SCF-PHY-010',
      section: '3',
      ref: '3.b.6',
      title: 'Rettigheder fastlagt — leverandør har ret til konfiskation og inspektion af medie',
      package: 3,
      addOns: [],
      text: `Rettigheder/ejendomsret til informationen på bærbare medier, der anvendes til levering af Ydelser, skal være fastlagt og Leverandøren har ret til at konfiskere eller inspicere mediet, således, at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-3.b.7',
      scfId: 'SCF-PHY-010',
      section: '3',
      ref: '3.b.7',
      title: 'Medieporte kun tilladt ved gyldig forretningsmæssig begrundelse',
      package: 3,
      addOns: [],
      text: `Leverandøren skal kun tillade brug af medieport ved leveringen af Ydelser, når der er en gyldig forretningsmæssig begrundelse.`,
    },

    // 3.c Databeskyttelse og dokumenthåndtering
    {
      externalId: 'SKI-3.c.1',
      scfId: 'SCF-DAT-001',
      section: '3',
      ref: '3.c.1',
      title: 'Kundens informationer beskyttes i henhold til kundens dataklassifikation',
      package: 1,
      addOns: [],
      text: `Kundens informationer, både elektroniske og fysiske, som Leverandøren og dennes medarbejdere får adgang til, skal beskyttes i henhold til Kundens klassificering af data.`,
    },
    {
      externalId: 'SKI-3.c.2',
      scfId: 'SCF-OPS-013',
      section: '3',
      ref: '3.c.2',
      title:
        'E-mail til kundedatatransmission: krypteret (CFCS-krav), anti-malware, ingen privat mail',
      package: 2,
      addOns: [],
      text: `Hvis Kunden tillader, at Leverandørens medarbejdere benytter e-mail til transmission af Kundens data, skal følgende være opfyldt:

- medarbejderne må kun efter aftale med Kunden benytte deres e-mailkonti hos Leverandøren
- Leverandørens e-mail servere skal være konfigurerede til at gennemtvinge kryptering med i overensstemmelse med Center for Cybersikkerheds minimumskrav hertil
- Leverandøren skal sørge for, at medarbejdernes e-mails scannes for ondsindet kode og blokeres, hvis sådan kode detekteres
- medarbejdere må ikke benytte private e-mail konti (fx gmail) til transmission af Kundens data`,
    },
    {
      externalId: 'SKI-3.c.3',
      scfId: 'SCF-DAT-001',
      section: '3',
      ref: '3.c.3',
      title: 'Kundedata beskyttes på alle lagringslocationer inkl. cloud og eksterne parter',
      package: 2,
      addOns: [],
      text: `Kundens data skal beskyttes i overensstemmelse med det tildelte klassifikationsniveau (f.eks. fortrolig, internt eller offentligt), uanset hvor de er lagret (f.eks. fysisk eller elektronisk, interne servere, cloud-miljøer eller hos eksterne leverandører).

Kundens data må kun deles via samarbejdsplatforme (f.eks MS Sharepoint, MS Teams, Slack, JIRA mv.) efter kundens anvisning og accept.`,
    },
    {
      externalId: 'SKI-3.c.4',
      scfId: 'SCF-DAT-002',
      section: '3',
      ref: '3.c.4',
      title:
        'Tekniske og operationelle kontroller for kritiske/følsomme data: adgang, kryptering, backup',
      package: 2,
      addOns: [],
      text: `Leverandørens behandlingen af Kundens kritiske og følsomme data skal beskyttes af en række tekniske og operationelle kontroller, som omfatter

- begrænsning af adgangen
- sikre lagringssystemer, der minimerer risiko for uautoriseret adgang
- filkryptering
- backup med henblik på reetablering`,
    },
    {
      externalId: 'SKI-3.c.5',
      scfId: 'SCF-DAT-002',
      section: '3',
      ref: '3.c.5',
      title: 'Databeskyttelsespolitik for behandling af persondata',
      package: 3,
      addOns: [],
      text: `Leverandøren skal, for at behandle persondata, som måtte være en del af behandlingsaktiviteterne for Kunden, have en databeskyttelsespolitik, der:

- er let tilgængelig for personer, der håndterer persondata
- regelmæssigt ajourført
- fastlægger retningslinjer for en række aktiviteter vedrørende behandling af persondata (f.eks. identifikation, håndtering, beskyttelse og destruktion),`,
    },
    {
      externalId: 'SKI-3.c.6',
      scfId: 'SCF-DAT-004',
      section: '3',
      ref: '3.c.6',
      title: 'Følsomme data underkastes datamaskeringsteknikker inden behandling',
      package: 3,
      addOns: [],
      text: `Følsomme data skal inden behandling underkastes datamaskeringsteknikker som f.eks.:

- sletning af tegn eller ændring af værdi
- pseudonymisering eller anonymisering
- tokenisering,`,
    },
    {
      externalId: 'SKI-3.c.7',
      scfId: 'SCF-PRV-007',
      section: '3',
      ref: '3.c.7',
      title: 'Behandling af persondata i overensstemmelse med GDPR i hele livscyklus',
      package: 2,
      addOns: [],
      text: `Behandling af persondata skal ske i overensstemmelse med relevant lovgivning (GDPR), hvorefter Leverandøren skal:

- beskytte persondata i hele sin livscyklus (dvs. under oprettelse, behandling, lagring (herunder sikkerhedskopiering og arkivering), transmission og destruktion)
- beskytte privatlivsrelaterede metadata (f.eks. dokumentattributter eller beskrivende oplysninger, der kan indeholde personlige oplysninger såsom navnet på den person, der sidst opdaterede en fil)`,
    },
    {
      externalId: 'SKI-3.c.8',
      scfId: 'SCF-INC-006',
      section: '3',
      ref: '3.c.8',
      title: 'Metode til håndtering af brud på privatlivets fred inkl. myndighedsunderretning',
      package: 3,
      addOns: [],
      text: `For persondata, skal leverandøren have en metode til håndtering af brud på privacy, som omfatter:

- identifikation af hvornår bruddet er sket
- proces for håndtering af bruddet
- underretning af relevante myndigheder og datasubjektet, som krævet i henhold til lovgivningen`,
    },

    // 3.d BYOD
    {
      externalId: 'SKI-3.d.1',
      scfId: 'SCF-AST-002',
      section: '3',
      ref: '3.d.1',
      title: 'BYOD-politik: aftale, EMM/MDM-kontroller og sikker app-udrulning',
      package: null,
      addOns: ['byod'],
      text: `Hvis Leverandøren tillader medarbejderne at bruge eget udstyr (dvs. f.eks. smartphones, tablets og bærbare computere som er ejet af medarbejderen) ved levering af Ydelser, skal denne brug være understøttet af dokumenterede standarder/procedurer, som omfatter:

- en aftale om medarbejderejet udstyr med angivelse af medarbejderens forpligtelser og Leverandørens rettigheder
- håndhævelse af brugen af tekniske kontroller (f.eks. Enterprise Mobility Management (EMM)) til styring af applikationer og enhedshardware
- sikker udrulning af virksomhedsapplikationer (f.eks. brug af et virtuelt skrivebord eller en sandkasse)`,
    },
    {
      externalId: 'SKI-3.d.2',
      scfId: 'SCF-AST-001',
      section: '3',
      ref: '3.d.2',
      title: 'Register over alle medarbejderejede enheder med enhedsspezifikation',
      package: null,
      addOns: ['byod'],
      text: `Alle medarbejderejede enheder, der benyttes til levering af Ydelser, skal føres i et register og indeholde specifikation af de tilladte typer enheder (f.eks. enhedens producent og model, operativsystem og sikkerhedsfunktioner).`,
    },
    {
      externalId: 'SKI-3.d.3',
      scfId: 'SCF-AST-002',
      section: '3',
      ref: '3.d.3',
      title: 'Underskrevet BYOD-aftale inden brug til arbejdsrelaterede aktiviteter',
      package: null,
      addOns: ['byod'],
      text: `Medarbejderne, der anvender eget udstyr ved levering af Ydelser, skal acceptere og underskrive en aftale om betingelserne for brug af udstyret, førend det må benyttes til adgang til arbejdsrelateret aktiviteter, systemer og applikationer.`,
    },
    {
      externalId: 'SKI-3.d.4',
      scfId: 'SCF-AST-002',
      section: '3',
      ref: '3.d.4',
      title:
        'BYOD-aftale specificerer adfærd, deling, datalagring og bortskaffelsesforrholdsregler',
      package: null,
      addOns: ['byod'],
      text: `Aftalen om brug af medarbejderejede enheder, der anvendes til levering af Ydelser, skal tydeligt:

- angive forventet sikkerhedsadfærd hos brugerne af enhederne (f.eks. de steder, hvor de må og ikke må bruges)
- forbyde deling af enheder og adgangskoder med andre personer (herunder familiemedlemmer og venner) og overgivelse af enheden til uautoriserede organisationer (f.eks. dem, der leverede udstyret, såsom enhedsproducenter og detailorganisationer og vedligeholdelsesorganisationer)
- definere begrænsninger for de typer oplysninger, der kan lagres på enheden (f.eks. kun ikke-følsomme oplysninger)
- beskrive de forholdsregler, der skal tages ved bortskaffelse af enheden (f.eks. fjernsletning af alle oplysninger på enheden),`,
    },
    {
      externalId: 'SKI-3.d.5',
      scfId: 'SCF-AST-002',
      section: '3',
      ref: '3.d.5',
      title: 'BYOD-aftale kræver databeskyttelse, fysisk sikkerhed og hændelsesrapportering',
      package: null,
      addOns: ['byod'],
      text: `Aftalen om brug af medarbejderejede enheder, der anvendes til levering af Ydelser, skal kræve, at medarbejderne:

- beskytter data lagret på enheden
- sørger for fysisk sikkerhed for enheden
- afstår fra at manipulere med sikkerhedsindstillinger eller godkendt software på enheden ("jailbreaking")
- straks rapporterer faktiske og formodede sikkerhedshændelser vedrørende enheden
- følger Leverandørens proces for løsning af software- og hardwaresupportproblemer,`,
    },
    {
      externalId: 'SKI-3.d.6',
      scfId: 'SCF-OPS-001',
      section: '3',
      ref: '3.d.6',
      title:
        'BYOD-aftale definerer leverandørens ret til administration, overvågning og fjernsletning',
      package: null,
      addOns: ['byod'],
      text: `Aftalen om brug af medarbejderejede enheder, der anvendes til levering af Ydelser, skal definere, under hvilke omstændigheder Leverandøren forbeholder sig ret til at:

- administrere enheden og de forretningsapplikationer, der kører på den
- håndhæve tekniske sikkerhedskontroller såsom adgangskontrol, malwarebeskyttelsessoftware og kryptering
- overvåge enheden og trafikken på den
- få adgang til, administrere, gendanne eller slette forretningsapps og personlige apps og data på medarbejderejede enheder
- fjernslette alle oplysninger på enheden i tilfælde af en sikkerhedshændelse, ved fratrædelse, eller enheden mistes eller stjæles,`,
    },
    {
      externalId: 'SKI-3.d.7',
      scfId: 'SCF-OPS-001',
      section: '3',
      ref: '3.d.7',
      title: 'Medarbejderejet enhed: ikke jailbroken, opdateret OS (N eller N-1), MDM-tilmeldt',
      package: null,
      addOns: ['byod'],
      text: `En medarbejderejet enhed, der anvendes til levering af Ydelser, skal være konfigureret til:

- ikke at være manipuleret ("jailbroken")
- at være opdateret til seneste eller seneste -1 godkendte version af operativsystemet
- være administreret i Leverandørens MDM eller EMM-system,`,
    },
    {
      externalId: 'SKI-3.d.8',
      scfId: 'SCF-NET-003',
      section: '3',
      ref: '3.d.8',
      title: 'Tekniske kontroller på BYOD: VPN, karantæne, adskillelse af apps, logning',
      package: null,
      addOns: ['byod'],
      text: `Der skal være implementeret tekniske kontroller på den medarbejderejet enhed, der anvendes til levering af Ydelser, som f.eks omfatter:

- adgangsbegrænsning (f.eks. ved hjælp af et virtuelt privat netværk (VPN), firewalls og proxyservere),
- at behandle enheden som upålidelige som standard og sætte den i indledende automatisk karantæne
- begrænsning af adgangen til data (f.eks. ved brug af adgangskontrol eller adskillelse af arbejdsrelaterede apps og personlige apps og data)
- beskyttelse af information ved tab eller tyveri af enheden
- vedligeholdelse af konfigurationsindstillinger (f.eks. automatiske opdateringer til operativsystemet og applikationerne)
- logning af sikkerhedsrelaterede hændelser (f.eks. når følsomme data kopieres til en anden enhed),`,
    },
    {
      externalId: 'SKI-3.d.9',
      scfId: 'SCF-PPL-003',
      section: '3',
      ref: '3.d.9',
      title: 'Medarbejdere uddannes i risici og sikkerhedskrav ved BYOD-brug',
      package: null,
      addOns: ['byod'],
      text: `Medarbejdere, der får adgang til Leverandørens systemer med eget udstyr, der anvendes til levering af Ydelser, skal undervises i risici og sikkerhedskrav ved brug af sådanne enheder.`,
    },

    // 3.e Logning og overvågning
    {
      externalId: 'SKI-3.e.1',
      scfId: 'SCF-OPS-006',
      section: '3',
      ref: '3.e.1',
      title: 'Logning og overvågning af slutbrugerudstyr og netværk for sikkerhedshændelser',
      package: 1,
      addOns: [],
      text: `Leverandøren skal logge og overvåge slutbrugerudstyr, netværk mv., der anvendes til levering af Ydelser, for at kunne opdage sikkerhedsrelaterede hændelser, som f.eks. uautoriseret aktivitet.`,
    },
    {
      externalId: 'SKI-3.e.2',
      scfId: 'SCF-DAT-005',
      section: '3',
      ref: '3.e.2',
      title:
        'DLP-overvågning ved behandling af kritisk/følsom information: detekter, bloker, advar',
      package: 3,
      addOns: [],
      text: `Uanset hvilke medier, der benyttes af Leverandørens medarbejdere til levering af Ydelser, skal Leverandøren implementere logning og overvågning ved behandling af Kundens kritisk forretningsinformation og/eller følsomme persondata. Overvågningen skal:

- opdage kritiske og følsomme oplysninger, når de videregives under behandling eller transmission
- blokere brugerhandlinger eller netværkstransmissioner, der afslører følsomme oplysninger
- underrette eller advare om aktiviteter og handlinger, der ikke må foretages`,
    },
    {
      externalId: 'SKI-3.e.3',
      scfId: 'SCF-DAT-005',
      section: '3',
      ref: '3.e.3',
      title:
        'DLP-værktøjer konfigureret med politikker for datastrøm: hvem, hvad, hvordan og håndhævelse',
      package: 3,
      addOns: [],
      text: `Overvågningsværktøjer, der anvendes ved levering af Ydelser, skal konfigureres til at overvåge og styre strømmen af følsomme data ved hjælp af tekniske politikker, der definerer:

- hvilke data der kan videregives
- hvor data kan videregives til
- hvem der kan sende og modtage data
- hvordan data kan videregives
- udførelse af håndhævelsesforanstaltninger som fx logning af overtrædelser af politikker og blokering af uautoriseret videregivelse.`,
    },

    // ── 4. Identitets- og adgangsstyring ────────────────────────────────────
    // 4.a Adgangsstyringspolitik
    {
      externalId: 'SKI-4.a.1',
      scfId: 'SCF-IAM-001',
      section: '4',
      ref: '4.a.1',
      title: 'Politik og retningslinjer for adgangsstyring til systemer og data',
      package: 1,
      addOns: [],
      text: `Leverandøren skal fastlægge en politik og retningslinjer, herunder for levering af Ydelser, for adgangsstyring for at styre identiteter og adgangsforhold til systemer og data.`,
    },
    {
      externalId: 'SKI-4.a.2',
      scfId: 'SCF-IAM-001',
      section: '4',
      ref: '4.a.2',
      title:
        'Politik specificerer mindste privilegium, funktionsadskillelse og individuel ansvarlighed',
      package: 2,
      addOns: [],
      text: `Politikken for adgangsstyring, jf. ovenfor, skal specificere principperne for adgangsstyring med henblik på at:

- overholde princippet om mindste privilegium
- sørge for funktionsadskillelse ved opgavevaretagelse
- sikre individuel ansvarlighed for hver bruger og systembruger
- anvende yderligere kontroller for brugere med særlige adgangsrettigheder`,
    },
    {
      externalId: 'SKI-4.a.3',
      scfId: 'SCF-IAM-004',
      section: '4',
      ref: '4.a.3',
      title: 'Dokumenterede IAM-procedurer: RBAC, kontoadministration, MFA, SSO og IAM-løsninger',
      package: 3,
      addOns: [],
      text: `Leverandørens implementering af adgangsstyring, jf. ovenfor, skal indeholde dokumenterede procedurer for:

- informationsklassificering
- håndtering af juridiske, reguleringsmæssige eller kontraktlige forpligtelser
- adgangskontrolordninger, (f.eks. rollebaseret adgangskontrol)
- kontoadministration, herunder oprettelse, ændring og sletning af bruger- (eller tjeneste) konti; og tildeling, ændring og fjernelse af adgangskontrolrettigheder eller -privilegier
- adgangskontrolmekanismer, herunder bruger-id'er og adgangskoder, tokens og biometri
- logonprocesser, (f.eks. singlesignon (SSO) og multifaktorautentificering (MFA))
- identitets- og adgangsstyringsløsninger (IAM),`,
    },

    // 4.b Identitets- og adgangsstyring
    {
      externalId: 'SKI-4.b.1',
      scfId: 'SCF-IAM-002',
      section: '4',
      ref: '4.b.1',
      title: 'Dokumenteret identitetslivscyklus: oprettelse, ændring og nedlæggelse',
      package: 1,
      addOns: [],
      text: `Leverandøren skal have etableret en dokumenteret identitetslivscyklus, som inkluderer procedurer for oprettelse, ændring og nedlæggelse af identiteter, således at kravet kan overholdes ved Leveringskontraktens opfyldelse.`,
    },
    {
      externalId: 'SKI-4.b.2',
      scfId: 'SCF-IAM-002',
      section: '4',
      ref: '4.b.2',
      title: 'Alle brugere identificerbare via unik identitet med sporing af handlinger',
      package: 1,
      addOns: [],
      text: `Alle brugere, deres login og deres handlinger i systemerne skal være identificerbare gennem en unik identitet, således kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-4.b.3',
      scfId: 'SCF-IAM-004',
      section: '4',
      ref: '4.b.3',
      title:
        'Konsistent metode for identifikation, autentifikation, autorisation og administration',
      package: 2,
      addOns: [],
      text: `Leverandøren skal have implementeret en konsistent og dokumenteret metode for:

- Identifikation af brugere
- Autentifikation af brugere
- Bruger sign-on proces
- Autorisering af adgangsrettigheder til brugere
- Administration af brugernes adgangsrettigheder,

således at kravet kan overholdes ved Leveringskontraktens opfyldelse.`,
    },
    {
      externalId: 'SKI-4.b.4',
      scfId: 'SCF-IAM-006',
      section: '4',
      ref: '4.b.4',
      title: 'Rollebaseret adgangsstyring (RBAC) for medarbejderes systemadgang',
      package: 3,
      addOns: [],
      text: `Leverandøren skal implementere adgangsstyring, (f.eks rollebaseret), for at styre medarbejdernes adgange til leverandørens systemer, således at kravet kan overholdes ved Leveringskontraktens opfyldelse.`,
    },

    // 4.c Kontoadministration
    {
      externalId: 'SKI-4.c.1',
      scfId: 'SCF-IAM-006',
      section: '4',
      ref: '4.c.1',
      title: 'Kontoadministration: tildeling, ændring, nedlæggelse og funktionsadskillelse',
      package: 1,
      addOns: [],
      text: `Kontoadministration til de af Leverandørens systemer skal implementeres for at:

- tildele, ændre eller nedlægge brugernes adgangsrettigheder i overensstemmelse med brugernes arbejdsbetingede behov
- rettidigt at nedlægge adgangsrettigheder ved fratrædelse
- opretholde funktionsadskillelse mellem oprettelse, godkendelse og tildeling af adgangsrettigheder.

således at kravet kan overholdes ved Leveringskontraktens opfyldelse.`,
    },
    {
      externalId: 'SKI-4.c.2',
      scfId: 'SCF-IAM-006',
      section: '4',
      ref: '4.c.2',
      title: 'Regelmæssig gennemgang af tildelte adgangsrettigheder mod arbejdsbetinget behov',
      package: 1,
      addOns: [],
      text: `Leverandøren skal foretage regelmæssig gennemgang af tildelte rettigheder til systemer, der benyttes ved levering af Ydelser, og kontrollere, at disse fortsat er i overensstemmelse med medarbejdernes arbejdsbetingede behov. Ved konstatering af, at de tildelte rettigheder overstiger medarbejderens arbejdsbetingede behov, skal rettighederne tilpasses i overensstemmelse med det faktiske behov.`,
    },
    {
      externalId: 'SKI-4.c.3',
      scfId: 'SCF-IAM-005',
      section: '4',
      ref: '4.c.3',
      title: 'Mindste-privilegium-kontroller for alle konto- og systemadgangstyper',
      package: 2,
      addOns: [],
      text: `Leverandøren skal have implementeret foranstaltninger i relation til Leveringskontraktens opfyldelse til at begrænse adgangen til systemer, applikationer, netværk, samarbejdsplatforme og slutbrugerudstyr for alle typer individuelle konti eller systemkonti. Disse adgangskontrolforanstaltninger skal:

- begrænse adgangen i overensstemmelse med Leverandørens adgangsstyringspolitik
- være baseret på princippet om mindste privilegium
- opretholde overensstemmelse mellem adgangsrettigheder og informationsklassifikationer
- begrænse og tilpasse rettigheder eller privilegier til brugere eller andre enheder med passende detaljeringsgrad (granularitet)`,
    },
    {
      externalId: 'SKI-4.c.4',
      scfId: 'SCF-IAM-005',
      section: '4',
      ref: '4.c.4',
      title: 'Udvidede rettigheder kun via separat bruger-id og MFA',
      package: 3,
      addOns: [],
      text: `Medarbejdere som har udvidede adgangsrettigheder skal:

- kun bruge deres udvidede adgangsrettigheder med et særligt bruger-id som ikke benyttes almindeligt dagligt arbejde
- benytte multi-factor authentication (MFA),

således at kravet`,
    },
    {
      externalId: 'SKI-4.c.5',
      scfId: 'SCF-IAM-005',
      section: '4',
      ref: '4.c.5',
      title: 'PAM-proces: begrundelse, register, tidsbe­grænset, logget og hyppigt kontrolleret',
      package: 3,
      addOns: [],
      text: `Der skal være en proces for og kontrol med udvidede adgangsrettigheder (f.eks. Root eller administratoradgang) til Leverandørens systemer, der anvendes ved levering af Ydelser, som omfatter, at tildeling af udvidede adgangsrettigheder skal være:

- begrundet og tildelte rettigheder anført i et register/database
- begrænset til absolut nødvendige funktioner og f.eks. tidsmæssigt begrænset
- logget og overvåget
- kontrolleret regelmæssigt og oftere end almindelige brugeradgange`,
    },
    {
      externalId: 'SKI-4.c.6',
      scfId: 'SCF-IAM-001',
      section: '4',
      ref: '4.c.6',
      title: 'Adgangskontrolordninger gennemgås og opdateres som reaktion på nye trusler',
      package: 3,
      addOns: [],
      text: `Adgangskontrolordningerne for adgang til systemer og data, der anvendes ved levering af Ydelser, skal gennemgås og opdateres regelmæssigt som reaktion på nye trusler, kapaciteter, sårbarheder og erfaring med informationssikkerhedshændelser, jf. seneste risikovurdering udarbejdet af Leverandøren.`,
    },

    // 4.d Adgangskontrolmekanismer
    {
      externalId: 'SKI-4.d.1',
      scfId: 'SCF-IAM-003',
      section: '4',
      ref: '4.d.1',
      title: 'Autentifikation med identifikator og autentifikator kræves inden systemadgang',
      package: 1,
      addOns: [],
      text: `Medarbejdere, der medvirker til levering af Ydelser, skal autentificeres ved hjælp af en identifikator og en autentifikator, før der gives adgang til informationer, applikationer, operativsystemer, slutbrugerenheder eller netværk.`,
    },
    {
      externalId: 'SKI-4.d.2',
      scfId: 'SCF-IAM-003',
      section: '4',
      ref: '4.d.2',
      title: 'God adgangskodeadfærd: hemmeligholdelse, ikke-ordbogs­ord, skift ved mistanke',
      package: 2,
      addOns: [],
      text: `Leverandøren skal understøtte god adfærd hos medarbejdere, som indebærer:

- at holde sine adgangskoder hemmelige
- at benytte adgangskoder, der ikke er baseret på dagligdags ord
- at skifte sine adgangskoder ved mistanke om kompromittering,

således at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-4.d.3',
      scfId: 'SCF-IAM-003',
      section: '4',
      ref: '4.d.3',
      title: 'Teknisk adgangskodestyring: min. 12 tegn, ingen klartekst, begrænset genbrug',
      package: 2,
      addOns: [],
      text: `Ved brug af passwords skal Leverandøren understøtte dette med tekniske foranstaltninger, der:

- stiller krav til passwords længde (minimum 12 karakterer) og kompleksitet
- ikke viser indtastning af password i klartekst (vises som *)
- begrænser genbrug af passwords,

således at kravet opfyldes ved levering af Ydelser.`,
    },

    // 4.e Fjernadgang
    {
      externalId: 'SKI-4.e.1',
      scfId: 'SCF-PPL-007',
      section: '4',
      ref: '4.e.1',
      title: 'Fjernadgang kun tilladt fra MDM/EMM-tilmeldt slutbrugerudstyr',
      package: null,
      addOns: ['remote-access'],
      text: `Hvis Leverandørens medarbejdere etablerer fjernadgang til Kundens systemer og data og/eller til Leverandørens systemer, netværk mv., der bruges ved levering af ydelserne til Kunden, er dette kun tilladt med slutbrugerudstyr, der er indlemmet i Leverandørens MDM- eller EMM-løsning.`,
    },
    {
      externalId: 'SKI-4.e.2',
      scfId: 'SCF-PPL-007',
      section: '4',
      ref: '4.e.2',
      title: 'Fjernadgang krypteret via VPN og kræver multifaktorgodkendelse',
      package: null,
      addOns: ['remote-access'],
      text: `Fjernadgangen, som etableres i henhold til 4.e.1 skal være krypteret (f.eks via VPN) og have multifaktor autentificering (MFA)`,
    },
    {
      externalId: 'SKI-4.e.3',
      scfId: 'SCF-PPL-007',
      section: '4',
      ref: '4.e.3',
      title:
        'Instruktioner til hjemmearbejde: router-adgangskode, MFA, ingen deling, fysisk sikkerhed',
      package: null,
      addOns: ['remote-access'],
      text: `Når fjernadgangen, jf. ovenfor, tillades hjemmefra, skal Leverandørens medarbejdere være instrueret i:

- at opsætte deres private router med et stærkt password
- at bruge multifaktor autentificering
- ikke at låne eller dele slutbrugerudstyret med nogen
- at beskytte udstyret mod tyveri,`,
    },
    {
      externalId: 'SKI-4.e.4',
      scfId: 'SCF-OPS-006',
      section: '4',
      ref: '4.e.4',
      title: 'Logning og overvågning af fjernadgangs-logon',
      package: null,
      addOns: ['remote-access'],
      text: `Leverandøren skal have implementeret logning og overvågning af logon med fjernadgangen, jf. ovenfor.`,
    },

    // 4.f Fysiske lokationer
    {
      externalId: 'SKI-4.f.1',
      scfId: 'SCF-PHY-001',
      section: '4',
      ref: '4.f.1',
      title: 'Fysiske adgangskontrolforanstaltninger der hindrer uvedkommende i at få adgang',
      package: 1,
      addOns: [],
      text: `Fysisk adgang til lokationer, hvorfra Leverandøren leverer Ydelser til Kunden, skal have foranstaltninger, så uvedkommende hindres adgang.`,
    },
    {
      externalId: 'SKI-4.f.2',
      scfId: 'SCF-PHY-002',
      section: '4',
      ref: '4.f.2',
      title: 'Sikringsforanstaltninger: adgangskort, alarm, videoovervågning, gæste­registrering',
      package: 2,
      addOns: [],
      text: `Leverandøren skal implementere sikringsforanstaltninger på sine lokationer, hvorfra der leveres Ydelser til Kunden, som f.eks.:

- adgangsstyringsmekanismer (lås og adgangskort)
- alarmsystem og evt. videoovervågning
- identifikationskort til medarbejdere
- registreringsordning og gæstekort til gæster,`,
    },
    {
      externalId: 'SKI-4.f.3',
      scfId: 'SCF-PHY-007',
      section: '4',
      ref: '4.f.3',
      title: 'Skærmplacement/filter, automatisk skærmlås og clean-desk-politik',
      package: 3,
      addOns: [],
      text: `Computerskærme, der anvendes ved levering af Ydelser og der benyttes på lokationer, skal være placeret, så de ikke er læsbar udefra, eller forsynet med skærmfilter. Automatisk skærmlås skal være implementeret og Leverandøren skal have en clean-desk politik.`,
    },

    // ── 5. Styring af underleverandører ─────────────────────────────────────
    {
      externalId: 'SKI-5.a.1',
      scfId: 'SCF-VDR-001',
      section: '5',
      ref: '5.a.1',
      title: 'Overblik over underleverandører og risikovurdering af disse',
      package: 1,
      addOns: [],
      text: `Leverandøren skal have et overblik over sine underleverandører, der medvirker til levering af Ydelser, og foretage risikovurderinger af disse underleverandører.`,
    },
    {
      externalId: 'SKI-5.a.2',
      scfId: 'SCF-VDR-002',
      section: '5',
      ref: '5.a.2',
      title: 'Retningslinjer for hvilken kundeinformation der deles med underleverandører',
      package: 2,
      addOns: [],
      text: `Leverandøren skal ved levering af Ydelser have retningslinjer, der angiver:

- hvilke typer af kundeinformationer, Leverandøren deler med sine underleverandører
- hvad underleverandøren har adgang til (f.eks. it-infrastruktur, netværk, og fysiske miljøer)`,
    },
    {
      externalId: 'SKI-5.a.3',
      scfId: 'SCF-VDR-002',
      section: '5',
      ref: '5.a.3',
      title: 'Underleverandøraftaler indeholder proportionale IS-krav',
      package: 1,
      addOns: [],
      text: `Enhver brug af en underleverandør til levering af Ydelser skal være understøttet af en kontrakt, hvori der er angivet krav til informationssikkerhed. Kravene til informationssikkerhed skal være proportionalt med de Ydelser, som underleverandøren leverer til Leverandøren og hermed Kunden.`,
    },
    {
      externalId: 'SKI-5.a.4',
      scfId: 'SCF-VDR-004',
      section: '5',
      ref: '5.a.4',
      title: 'Mindst årlig risikovurdering af kritiske underleverandørers IS-status',
      package: 3,
      addOns: [],
      text: `Leverandøren skal regelmæssigt ved levering af Ydelser - og minimum årligt - foretage risikovurderinger af kritiske underleverandører, som omfatter:

- de informationer, der behandles af underleverandøren
- sikkerhedsforanstaltninger, som underleverandøren benytter til at beskytte kritiske og følsomme informationer
- forretningsmæssige betydning, hvis underleverandøren kompromitteres`,
    },
    {
      externalId: 'SKI-5.a.5',
      scfId: 'SCF-VDR-004',
      section: '5',
      ref: '5.a.5',
      title: 'Regelmæssig vurdering af underleverandørers IS-status via godkendt metode',
      package: 3,
      addOns: [],
      text: `For underleverandører, der medvirker til levering af Ydelser, gælder, at disse underleverandørers informationssikkerhedsstatus skal vurderes regelmæssigt ved hjælp af en konsekvent og godkendt metode`,
    },

    // ── 6. Sikkerhedshændelser ──────────────────────────────────────────────
    {
      externalId: 'SKI-6.a.1',
      scfId: 'SCF-INC-001',
      section: '6',
      ref: '6.a.1',
      title:
        'Hændelseshåndteringsproces: detektering, analyse, prioritering, respons og kommunikation',
      package: 1,
      addOns: [],
      text: `Leverandøren skal have en proces til styring og håndtering af informationssikkerhedshændelser, der som minimum indeholder følgende trin:

- detektering og dokumentation
- analyse
- prioritering og klassificering
- respons og afhjælpning
- kommunikation til relevante parter,

således at kravet ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-6.a.2',
      scfId: 'SCF-INC-001',
      section: '6',
      ref: '6.a.2',
      title: 'Medarbejdere informeres om ansvar for og metode til indrapportering af hændelser',
      package: 1,
      addOns: [],
      text: `Leverandøren skal sørge for, at Leverandørens medarbejdere er informeret om deres ansvar for at indrapportere sikkerhedshændelser, -brud eller identificerede sårbarheder. Leverandøren skal sørge for, at medarbejderne har viden om, hvordan de skal indrapportere en sikkerhedshændelse (f.eks. notering af alle relevante detaljer og øjeblikkelig rapportering til kontaktpunktet), således at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-6.a.3',
      scfId: 'SCF-INC-002',
      section: '6',
      ref: '6.a.3',
      title:
        'Hændelseshåndteringsinformation let tilgængelig inkl. godkendt tidskilde til forensic data',
      package: 2,
      addOns: [],
      text: `Leverandøren skal sørge for, at oplysninger, der er nødvendige for at håndtere informationssikkerhedshændelser, er let tilgængelige og omfatter:

- kontaktoplysninger på relevante parter
- kontraktlige forpligtelser
- sikkerhedsrelaterede hændelseslogfiler
- detaljer om berørte it-miljøer, herunder skal der være en godkendt tidskilde til sikring af forensic data

således at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-6.a.4',
      scfId: 'SCF-INC-001',
      section: '6',
      ref: '6.a.4',
      title: 'Hændelsesrespons: loganalyse, bevissikring, skadesminimering og kommunikation',
      package: 3,
      addOns: [],
      text: `Leverandørens reaktion på konstaterede informationssikkerhedshændelser skal omfatte:

- analyse af tilgængelige oplysninger, såsom system-, net- og tekniske logfiler og logfiler fra relevante sikkerhedsprodukter (f.eks. software til beskyttelse mod malware, forebyggelse af datalækage (DLP) og netværksbaserede systemer til detektering af indtrængen (NIDS))
- håndtering af nødvendigt bevismateriale (f.eks. indsamling i overensstemmelse med retlige begrænsninger og beskyttelse mod uautoriseret manipulation)
- foranstaltninger for at minimere skaden og forhindre yderligere spredning af hændelsen
- prioritering og klassificering af hændelsen
- kommunikation af forløbet omkring hændelsen til relevante kunder, samarbejdspartnere og myndigheder

således at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-6.a.5',
      scfId: 'SCF-INC-006',
      section: '6',
      ref: '6.a.5',
      title:
        'Identificere juridiske/regulatoriske krav under en hændelse inkl. indberetningsfrister',
      package: 3,
      addOns: [],
      text: `Leverandøren skal identificere relevante juridiske og reguleringsmæssige krav, der skal opfyldes under en sikkerhedshændelse, som omfatter:

- sikkerhedsrelaterede love og bestemmelser, der er relevante for hændelsen
- eventuelle specifikke krav (f.eks. opbevaring af oplysninger til yderligere undersøgelse eller indsendelse af underretninger om brud til berørte personer og relevante myndigheder)
- tidsplaner for indberetning af hændelser (f.eks. tidsramme, inden for hvilken et brud på datasikkerheden skal indberettes til tilsynsorganerne,

således at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-6.a.6',
      scfId: 'SCF-INC-003',
      section: '6',
      ref: '6.a.6',
      title: 'Regelmæssige øvelser der tester hændelseshåndteringsprocesserne',
      package: 3,
      addOns: [],
      text: `Leverandøren skal gennemføre regelmæssige øvelser for at teste processerne til styring af sikkerhedshændelser, således at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-6.a.7',
      scfId: 'SCF-BCM-001',
      section: '6',
      ref: '6.a.7',
      title:
        'Beredskabsforanstaltninger sikrer fortsat levering af kritiske ydelser under hændelse',
      package: 3,
      addOns: [],
      text: `Leverandøren skal have beredskabsmæssige foranstaltninger, der:

- gør Leverandøren i stand til at håndtere hændelser, så levering af kritiske Ydelser til Kunden kan fortsætte uagtet hændelsen
- inkluderer underleverandører, hvor deres Ydelser er kritiske for Kunden
- sørger for at integritet af systemer og data, der er en del af Ydelsen, bevares

Kunden skal informeres om hændelser, der har betydning for levering af Ydelser til Kunden`,
    },

    // ── 7. Sikkerhed i systemudvikling og -konfiguration ────────────────────
    // 7.a Projektledelse
    {
      externalId: 'SKI-7.a.1',
      scfId: 'SCF-GOV-008',
      section: '7',
      ref: '7.a.1',
      title: 'IS integreres i alle faser af projektledelsesprocessen',
      package: null,
      addOns: ['project'],
      text: `Leverandøren skal ved varetagelse af projektledelse for Kunden sørge for, at informationssikkerhed er integreret i alle trin i projektstyringsprocessen, og særligt ved at:

- identificere informationssikkerhedskrav i de tidlige faser af projektet
- planlægge hvordan informationssikkerhedskravene opfyldes
- vurdere og behandle af informationssikkerhedsrisici i alle faser af projektet
- afprøve sikkerhedskontrollernes effektivitet,`,
    },
    {
      externalId: 'SKI-7.a.2',
      scfId: 'SCF-GOV-008',
      section: '7',
      ref: '7.a.2',
      title: 'Projektet tilpasses kundens informationssikkerhedsstrategi',
      package: null,
      addOns: ['project'],
      text: `Leverandøren skal ved varetagelse af projektledelsesansvaret redegøre for, hvordan projektet tilpasser sig til Kundens informationssikkerhedsstrategi.`,
    },
    {
      externalId: 'SKI-7.a.3',
      scfId: 'SCF-GOV-008',
      section: '7',
      ref: '7.a.3',
      title: 'Bidrage med viden om IS-produkter og -tjenester af betydning for projektet',
      package: null,
      addOns: ['project'],
      text: `Leverandøren skal kunne bidrage med viden om behov for informationssikkerhedsrelaterede produkter eller tjenester, der er af betydning for projektets sikkerhedsmæssige kapaciteter.`,
    },
    {
      externalId: 'SKI-7.a.4',
      scfId: 'SCF-GOV-008',
      section: '7',
      ref: '7.a.4',
      title: 'Medarbejdere uddannet i og anvender dokumenteret SDLC-metode',
      package: null,
      addOns: ['project'],
      text: `Når Leverandøren bidrager med udviklingsmetoder, skal Leverandørens medarbejdere være uddannede i at arbejde efter en dokumenteret systemudviklingsmetode (SDLC), som er baseret på god systemudviklings- og projektledelsespraksis, så projektets leverancer:

- overholder juridiske og lovgivningsmæssige krav
- overholder Kundens politikker, standarder og procedurer for informationssikkerhed
- opfylder Kundens forretningsmæssige krav til informationssikkerhed i projektet,`,
    },

    // 7.b Sikkerhed i udviklings- og konfigurationslivscyklus
    {
      externalId: 'SKI-7.b.1',
      scfId: 'SCF-DEV-004',
      section: '7',
      ref: '7.b.1',
      title: 'Sikre programmeringsteknikker, OWASP/CWE-vejledning og security by design',
      package: null,
      addOns: ['development'],
      text: `Leverandørens medarbejdere, som får adgang til at foretage systemudvikling og -konfiguration på Kundens kritiske systemer og applikationer skal være trænet i og anvende en dokumenteret metode, der omfatter:

- at bruge godkendte, sikre programmeringsteknikker
- at overholde god kodningspraksis
- principper for sikkerhedsarkitektur og applikationssikkerhed
- sikker kodevejledning (f.eks OWASP Top-10 og SANS/CWE Top-25 programmeringsfejl)
- principper om indbygget sikkerhed (security by design and by default)
- logning og overvågning mv,`,
    },
    {
      externalId: 'SKI-7.b.2',
      scfId: 'SCF-DEV-002',
      section: '7',
      ref: '7.b.2',
      title: 'Udviklingsmetode opdateres løbende med ny praksis inden for sikkerhed og levering',
      package: null,
      addOns: ['development'],
      text: `Leverandøren skal sørge for, at metoden opdateres med nye tiltag/praksis inden for:

- Udviklingsteknikker inden for programmering
- Leveringsmetoder til applikationer (f.eks. Cloud)
- Applikationsarkitektur
- Sikkerhedsstandarder og -teknikker,`,
    },
    {
      externalId: 'SKI-7.b.3',
      scfId: 'SCF-DEV-004',
      section: '7',
      ref: '7.b.3',
      title: 'Medarbejdere kan skrive sikker kode og anvende open source sikkert',
      package: null,
      addOns: ['development'],
      text: `Leverandørens medarbejdere, der skal udvikle og/eller konfigurere på Kundens systemer og applikationer, skal være i stand til at skrive sikker kode og trænes i brugen af open source-software, så blandede applikationer er sikre ved design.`,
    },
    {
      externalId: 'SKI-7.b.4',
      scfId: 'SCF-DEV-008',
      section: '7',
      ref: '7.b.4',
      title:
        'Dokumenteret tilpasningsproces for ændring af tredjeparts software med risikovurdering',
      package: null,
      addOns: ['development'],
      text: `Hvis basiskoden i eksterne parters/tredjeparters softwarepakker, som Kunden anvendes, ændres, skal der anvendes en dokumenteret tilpasningsproces, som tager højde for risikoen for:

- at eksterne parters/tredjeparters ikke længere vil supportere softwaret
- at indbyggede sikkerhedskontroller ikke længere virker
- at softwaret fremadrettet vil være vanskeligt at opdatere,

Dette må kun gøres med Kundens risikoaccept.`,
    },
    {
      externalId: 'SKI-7.b.5',
      scfId: 'SCF-IAM-007',
      section: '7',
      ref: '7.b.5',
      title: 'Medarbejdere trænet i versionsstyring og sikker opbevaring af kildekode',
      package: null,
      addOns: ['development'],
      text: `Leverandørens medarbejdere skal være trænet i versionsstyring og sikker opbevaring af kildekode, således at kravet opfyldes ved levering af Ydelser.`,
    },
    {
      externalId: 'SKI-7.b.6',
      scfId: 'SCF-DEV-007',
      section: '7',
      ref: '7.b.6',
      title:
        'Sikker SDLC: dedikerede miljøer, ingen secrets i kode, versionskontrol og formel ændringsproces',
      package: null,
      addOns: ['development'],
      text: `Leverandørens medarbejdere, der udvikler og konfigurerer systemer og applikationer for Kunden, skal være uddannede i at bruge alle aspekter af systemudviklingsmetoden på en sikker og effektiv måde. Dette omfatter:

- kun at udvikle i et dedikeret udviklingsmiljø – aldrig i driftsmiljøet
- forhindre udviklingsmedarbejdere i at foretage uautoriserede ændringer i levende miljøer
- Kun at teste i et dedikeret testmiljø – aldrig i driftsmiljøet
- fjerne unødvendige følsomme oplysninger fra programmer (f.eks. godkendelsesoplysninger eller krypterings-/API-nøgler i udviklernes kommentarer), før de implementeres i livemiljøet
- anvendelse af en centraliseret metode til lagring af kode
- anvendelse af streng versionskontrol over systemudviklingssoftware
- at ændringer af systemer skal udføres i overensstemmelse med en formel, dokumenteret proces, så de ikke påvirker den tilsigtede funktionalitet negativt eller kompromitterer sikkerhedskontrollerne`,
    },

    // 7.c Kvalitetssikring og Test
    {
      externalId: 'SKI-7.c.1',
      scfId: 'SCF-DEV-005',
      section: '7',
      ref: '7.c.1',
      title: 'Kvalitetssikring i alle faser af systemudviklingens livscyklus',
      package: null,
      addOns: ['development'],
      text: `Leverandøren skal sørge for, at systemudviklings- og konfigurationsaktiviteter, der udføres ved levering af Ydelser, er underlagt kvalitetssikring i alle faser af systemudviklingens livscyklus.`,
    },
    {
      externalId: 'SKI-7.c.2',
      scfId: 'SCF-DEV-005',
      section: '7',
      ref: '7.c.2',
      title: 'QA kontrollerer sikkerhedskrav, verificerer kontrollers effektivitet og dokumenterer',
      package: null,
      addOns: ['development'],
      text: `Kvalitetssikring af systemudviklings- og konfigurationsaktiviteter skal omfatte:

- kontrol af, at sikkerhedskravene er klart defineret
- bekræftelse af, at de sikkerhedskontroller, der blev aftalt under informationsrisikovurderingsprocessen, er blevet udviklet og fungerer korrekt
- dokumentation af kvalitetssikringen`,
    },
    {
      externalId: 'SKI-7.c.3',
      scfId: 'SCF-DEV-009',
      section: '7',
      ref: '7.c.3',
      title:
        'Test i separat testmiljø med teststrategi, rollebaserede scenarier og testdatabeskyttelse',
      package: null,
      addOns: ['development'],
      text: `Når Leverandørens medarbejdere udfører test af ny- eller videreudviklede/konfigurerede systemer og applikationer ved levering af Ydelser til Kunden, skal test heraf:

- følge en udarbejdet teststrategi, der inkluderer forskellige former for manuelle og automatiserede tests
- udføres for forskellige scenarier (f.eks. forskellige brugerroller og angrebsvektorer)
- udføres i et separat testmiljø, der i så høj grad som muligt ligner det virkelige produktionsmiljø
- udføres med data, der bidrager til testens pålidelighed samtidig med, at fortroligheden af følsomme og kritiske data ikke kompromitteres

Kunden skal informeres om forhold ved test, der ikke overholder ovenstående, og som har betydning for levering af Ydelser til Kunden.`,
    },

    // ── 8. Efterlevelse, opfølgning og revision ─────────────────────────────
    // Not part of the Bilag B.3 package system (out of scope per product decision) —
    // an ISAE 3000 audit/follow-up obligation that applies regardless of package
    // selection, not one the package matrix gates. package/addOns are left empty
    // so resolveApplicableRequirements() never surfaces it.
    {
      externalId: 'SKI-8.a.1',
      scfId: 'SCF-AUD-001',
      section: '8',
      ref: '8.a.1',
      title:
        'Opfølgning på leverandørens efterlevelse af sikkerhedskrav (ISAE 3000-revisionsgrundlag)',
      package: null,
      addOns: [],
      text: `Redaktionel note (ikke citeret fra Pakke-tabellen i Bilag B.3): dette krav-id er ikke et nummereret pakkekrav fra afsnit 3 "Sikkerhedspakker" — det repræsenterer leverandørens efterlevelse af sikkerhedskravene via et ISAE 3000-revisionsgrundlag, jf. Bilag B.3 afsnit 8 "Efterlevelse, opfølgning og revision".`,
    },
  ],
};

module.exports = {
  FRAMEWORK_SKI_0215,
};
